module.exports = __webpack_public_path__ + "img/unlock-slide-blue-green-gif.ca2c92fa.gif";